/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum(
  "TableRowHeightVMBehavior",
  ["BehaviorBase"],
  /**
   * Manage "height" attribute on widgets to set table row height
   * @param {gbc} context
   * @param {classes} cls
   */
  function (context, cls) {
    /**
     * @class TableRowHeightVMBehavior
     * @memberOf classes
     * @extends classes.BehaviorBase
     */
    cls.TableRowHeightVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
      return /** @lends classes.TableRowHeightVMBehavior.prototype */ {
        __name: "TableRowHeightVMBehavior",

        watchedAttributes: {
          decorator: ["height"]
        },

        /**
         *
         */
        _apply: function (controller, data) {
          const widget = controller.getWidget();
          if (widget?.setReservedRowHeight) {
            const height = controller.getNodeBindings().decorator.attribute("height");
            if (data.savedHeight !== height) {
              data.savedHeight = height;
              let reservedRowHeight = 0;
              if (height > 1) {
                // Transform nb of characters to pixels
                const fontInfo = cls.Measurement.fontInfo(widget.getElement());
                reservedRowHeight = cls.Measurement.measuredHeight(fontInfo["font-family"], fontInfo["font-size"], height);
              }
              // reset to 0 when height drops back to <= 1 so the row shrinks again
              widget.setReservedRowHeight(reservedRowHeight);
            }
          }
        }
      };
    });
  }
);
